import { render, staticRenderFns } from "./asyncSubmenu.vue?vue&type=template&id=262a9652&"
import script from "./asyncSubmenu.vue?vue&type=script&lang=js&"
export * from "./asyncSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262a9652')) {
      api.createRecord('262a9652', component.options)
    } else {
      api.reload('262a9652', component.options)
    }
    module.hot.accept("./asyncSubmenu.vue?vue&type=template&id=262a9652&", function () {
      api.rerender('262a9652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/asideComponent/asyncSubmenu.vue"
export default component.exports